import React from 'react';
import { Routes, Route } from 'react-router-dom';
import GettingStarted from './components/GettingStarted';
import FAQ from './components/FAQ';
import Tutorials from './components/Tutorials';
import Features from './components/Features';
import API from './components/API';
import Integrations from './components/Integrations';
import RuleEngine from './components/RuleEngine';
import Security from './components/Security';
import Sidebar from './Sidebar';

export default function DocsPage() {
  return (
    <>
      <div className="min-h-screen bg-[var(--color-background)] flex">
        <Sidebar />
        <main className="px-10">
          <Routes>
            <Route path="baslangic" element={<GettingStarted />} />
            <Route path="sss" element={<FAQ />} />
            <Route path="egitimler" element={<Tutorials />} />
            <Route path="ozellikler" element={<Features />} />
            <Route path="api" element={<API />} />
            <Route path="entegrasyonlar" element={<Integrations />} />
            <Route path="kural-motoru" element={<RuleEngine />} />
            <Route path="guvenlik" element={<Security />} />
          </Routes>
        </main>
      </div>
    </>
  );
} 